import {
  CommentsTypeEnum,
  GetIncidentByIdResponse,
} from '@EHSNavigator/backend/dist/api';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';

interface ChangesHistoryProps {
  otherClasses?: string;
  data: GetIncidentByIdResponse['incident']['taskHistory'];
}

const ChangesHistory: React.FC<ChangesHistoryProps> = ({
  otherClasses,
  data,
}) => {
  const changesHistoryClasses = clsx(
    otherClasses,
    'border-t-neutral-tones-text/10 mt-9 grid grid-cols-1 gap-6 border-t pt-9 md:gap-9',
  );

  return (
    <div className={changesHistoryClasses} data-testid="changes-history">
      <div className={clsx('col-span-1')}>
        <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
          Changes History
        </h6>

        <div className="flex w-full flex-col gap-5 sm:w-fit">
          {data?.map(({ user, title, createdAt, comment }, index) => {
            let beforeWord = '';
            let details = '';
            const match = title.match(/^(.+?)\s*\((.*?)\)$/);
            if (match) {
              beforeWord = match[1];
              details = match[2];
            } else {
              beforeWord = title;
            }

            return (
              <div className="relative" key={index}>
                <h6 className="font-inter-variable text-neutral-tones-text -tracking-button relative mb-2.5 flex w-full items-center gap-2.5 text-lg leading-5 font-bold sm:w-fit lg:text-xl lg:leading-6">
                  {beforeWord}
                  {(comment || details) && (
                    <button className="group text-brand-byzantine -tracking-form-label z-20 cursor-pointer text-sm leading-4 font-bold">
                      <WarningIcon
                        className={clsx(
                          'h-4 w-4',
                          comment?.type === CommentsTypeEnum?.Reason
                            ? '[&>g>path]:fill-brand-posh-pink'
                            : '[&>g>path]:fill-brand-byzantine',
                        )}
                      />
                      <p className="bg-neutral-tones-sidebar text-neutral-tones-text absolute bottom-full left-2/4 z-10 hidden w-full -translate-x-2/4 rounded px-2 py-1 text-xs font-normal shadow-lg group-hover:!line-clamp-[10] group-hover:block group-focus:!line-clamp-[10] group-focus:block sm:-right-0 sm:left-auto sm:w-auto sm:max-w-280 sm:translate-x-2/4">
                        {comment?.comment || details}
                      </p>
                    </button>
                  )}
                </h6>
                {user?.fullName && (
                  <p className="text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                    by <span className="underline">{user?.fullName}</span>
                  </p>
                )}
                <div className="mt-2.5">
                  <p className="text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                    {moment(createdAt).format('MMMM D, YYYY')}
                  </p>
                  <p className="text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                    {moment(createdAt).format('h:mm A')}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ChangesHistory;
